import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PeopleIcon from '@mui/icons-material/People';
import WorkIcon from '@mui/icons-material/Work';
import { Box, styled } from '@mui/material';
import { isEmpty } from 'lodash-es';
import {
  WsDetailsObj,
  WsIconLocation,
  WsIconJobOutline,
  WsIconPersons,
  WsIconVisa,
  WsColors,
  IFilterList,
} from 'wisestep-base';

import { failed, success, warning } from '../../../../utils/NotificationMessages';
import ICareerBuilderEdgeAdvanceSearch from '../types/ICareerBuilderEdgeAdvanceSearch';

export const LayoutTheme = styled(Box)(() => ({
  maxWidth: '100%',
  maxHeight: 'xs',
  backgroundColor: WsColors.TertiaryShades50,
}));

export const AppLayoutTheme = styled(Box)(() => ({
  borderRadius: 8,
  backgroundColor: WsColors.TheBlues900,
}));

export enum CandidateType {
  SUBMISSIONS = 'submissions',
  TALENTPOOL = 'talentpool',
  PIPELINE = 'pipeline',
  SMART_SOURCE = 'smartSource',
}

export const copySuccess = () => success('Copied Successfully !!');
export const copyFailed = () => failed('Copy failed !! ');
export const copyWarn = () => warning('Clipboard not supported');

export const getBotCandidateDetails = (candidate): WsDetailsObj[] => {
  const array: WsDetailsObj[] = [];
  array.push({
    icon: <WsIconLocation />,
    labelName: candidate.Location
      ? `${
          (candidate.Location.City ? candidate.Location.City : '') +
          ',' +
          (candidate.Location.State ? candidate.Location.State : '')
        }` ?? 'Not Available'
      : 'Not Available',
    popOverText: 'Candidate Location',
  });
  array.push({
    icon: <WsIconJobOutline />,
    labelName: candidate.JobTitle ?? 'Not Available',
    popOverText: 'Candidate Profile',
  });
  array.push({
    icon: <WsIconPersons />,
    labelName:
      (candidate.YearsOfExperience && `${candidate.YearsOfExperience} Year Experience`) ??
      'Not Available',
    popOverText: 'Candidate Experience',
  });

  array.push({
    icon: <WsIconVisa />,
    labelName:
      candidate.Educations && candidate.Educations.length > 0
        ? 'Highest Degree: ' + candidate.Educations[0].DegreeLevel
        : '' ?? 'Not Available',
    popOverText: 'Candidate Visa',
  });
  return array;
};

export const pushSearchFilters = (data: ICareerBuilderEdgeAdvanceSearch) => {
  const filtersArray: IFilterList[] = [];
  if (!isEmpty(data.searchPattern))
    filtersArray.push({
      tag: `Search Pattern: ${data.searchPattern}`,
      id: 'searchPattern',
    });
  if (!isEmpty(data.AcademicDiscipline))
    filtersArray.push({
      tag: `Academic Discipline: ${data.AcademicDiscipline.join(',')}`,
      id: 'AcademicDiscipline',
    });
  if (!isEmpty(data.City))
    filtersArray.push({
      tag: `City: ${data.City.join(',')}`,
      id: 'City',
    });
  if (!isEmpty(data.ContactInfo))
    filtersArray.push({
      tag: `Contact Info: ${data.ContactInfo.join(',')}`,
      id: 'ContactInfo',
    });
  if (!isEmpty(data.Country))
    filtersArray.push({
      tag: `Country: ${data.Country.join(',')}`,
      id: 'Country',
    });
  if (!isEmpty(data.CurrentEmployer))
    filtersArray.push({
      tag: `Current Employer: ${data.CurrentEmployer.join(',')}`,
      id: 'CurrentEmployer',
    });
  if (!isEmpty(data.CurrentlyEmployed))
    filtersArray.push({
      tag: `Currently Employed: ${data.CurrentlyEmployed.join(',')}`,
      id: 'CurrentlyEmployed',
    });
  if (!isEmpty(data.DegreeLevel))
    filtersArray.push({
      tag: `Degree Level: ${data.DegreeLevel.join(',')}`,
      id: 'DegreeLevel',
    });
  if (!isEmpty(data.DesiredJobType))
    filtersArray.push({
      tag: `Desired Job Type: ${data.DesiredJobType.join(',')}`,
      id: 'DesiredJobType',
    });
  if (!isEmpty(data.EdgeScore))
    filtersArray.push({
      tag: `Edge Score: ${data.EdgeScore.join(',')}`,
      id: 'EdgeScore',
    });
  if (!isEmpty(data.HasResume))
    filtersArray.push({
      tag: `Has Resume: ${data.HasResume.join(',')}`,
      id: 'HasResume',
    });
  if (!isEmpty(data.Industry))
    filtersArray.push({
      tag: `Industry: ${data.Industry.join(',')}`,
      id: 'Industry',
    });
  if (!isEmpty(data.JobTitle))
    filtersArray.push({
      tag: `Job Title: ${data.JobTitle.join(',')}`,
      id: 'JobTitle',
    });
  if (!isEmpty(data.PreviousEmployer))
    filtersArray.push({
      tag: `Previous Employer: ${data.PreviousEmployer.join(',')}`,
      id: 'PreviousEmployer',
    });
  if (!isEmpty(data.ResumeModified))
    filtersArray.push({
      tag: `Resume Modified: ${data.ResumeModified.join(',')}`,
      id: 'ResumeModified',
    });
  if (!isEmpty(data.SecurityClearance))
    filtersArray.push({
      tag: `Security Clearance: ${data.SecurityClearance.join(',')}`,
      id: 'SecurityClearance',
    });
  if (!isEmpty(data.Skill))
    filtersArray.push({
      tag: `Skill: ${data.Skill.join(',')}`,
      id: 'Skill',
    });
  if (!isEmpty(data.Source))
    filtersArray.push({
      tag: `Source: ${data.Source.join(',')}`,
      id: 'Source',
    });
  if (!isEmpty(data.State))
    filtersArray.push({
      tag: `State: ${data.State.join(',')}`,
      id: 'State',
    });
  if (!isEmpty(data.WillingToRelocate))
    filtersArray.push({
      tag: `Willing To Relocate: ${data.WillingToRelocate.join(',')}`,
      id: 'WillingToRelocate',
    });
  if (!isEmpty(data.zipcode))
    filtersArray.push({
      tag: `Zip Code: ${data.zipcode}`,
      id: 'zipcode',
    });
  if (!isEmpty(data.WorkStatus))
    filtersArray.push({
      tag: `Work Status: ${data.WorkStatus.join(',')}`,
      id: 'WorkStatus',
    });
  if (!isEmpty(data.YearsOfExperience))
    filtersArray.push({
      tag: `Years Of Experience: ${data.YearsOfExperience.join(',')}`,
      id: 'YearsOfExperience',
    });
  return filtersArray;
};

export interface ICareerBuilderEdgeSearchStateProps {
  appliedFilters: IFilterList[];
}
export const defaultCareerBuilderEdgeSearchStateReq: ICareerBuilderEdgeSearchStateProps = {
  appliedFilters: [],
};
export const SmallBoxWithRadius = styled(Box)(() => ({
  border: '1px solid ',
  borderColor: WsColors.TheBlues500,
  borderRadius: 8,
  paddingLeft: 8,
  paddingRight: 8,
  height: 25,
  alignItems: 'center',
}));

export const WorkAuthorization = new Map<string, string>();
WorkAuthorization.set('CTAY', 'Can work for any employer');
WorkAuthorization.set('CTCT', 'US Citizen');
WorkAuthorization.set('CTEM', 'H1 Visa');
WorkAuthorization.set('CTGR', 'Green Card Holder');
WorkAuthorization.set('CTNO', 'Need H1 Visa Sponsor');
WorkAuthorization.set('CTNS', 'Not Speciﬁed');
WorkAuthorization.set('EATN', 'TN Permit Holder');
WorkAuthorization.set('EAEA', 'Employment Authorization Document');

export const searchPatternOptions = [
  { label: 'Match All Keywords', value: 'All' },
  { label: 'Match Any Keywords', value: 'Any' },
  { label: 'Match Exact Keywords', value: 'Exact' },
  { label: 'Match keyword using Boolean Logic', value: 'Boo' },
];

export const getCareerBuilderEdgeCandidateDetails = (candidate) => [
  {
    icon: <LocationOnIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${candidate.Location.City},${candidate.Location.State} ${candidate.Location.Country}`,
    tooltip: 'Location',
  },
  {
    icon: <LibraryBooksIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Job Title: ${candidate.JobTitle}`,
    tooltip: 'Job Title',
  },
  {
    icon: <PeopleIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Experience: ${candidate.YearsOfExperience}`,
    tooltip: 'Experience',
  },
  {
    icon: <WorkIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Recent Employer: ${candidate.Employments[0]?.Employer ?? ''}`,
    tooltip: 'Recent Employer',
  },
  {
    icon: <PeopleIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Source: ${candidate.candidateData.source}`,
    tooltip: 'Source',
  },
  {
    icon: <LibraryBooksIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Edge Score: ${candidate.EdgeScore ?? 'N/A'}`,
    tooltip: 'Edge Score',
  },
];
